'use strict';

module.exports = window.config;
